export { default } from "ember-stargate/components/portal-target";
